export function getPostboxDocumentsEndpoint(): string {
    return '/postbox-documents';
}

export function getPostboxDocumentDataEndpoint(documentId: string): string {
    return `${getPostboxDocumentsEndpoint()}/${documentId}`;
}
